module.exports = __webpack_public_path__ + "media/images/flags/jm-6b49055411bac7434284bb1ed04e7b25.svg";